export const VISIBLE_SLOTS_THRESHOLD = 7;
export const ACUITY_DEFAULT_TIMEZONE = "America/Los_Angeles";
